import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SAccountSettings.css';
import { useParams } from 'react-router-dom';

const SAccountSettings = () => {
  const [formData, setFormData] = useState({
    Name: '',
    Mobile_no: '',
    email: '',
  });
  const { pk } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const response = await axios.get(`https://terracharms.com/seller_profile/${pk}/`);
        const data = response.data;
        setFormData({
          Name: data.Name || '',
          Mobile_no: data.Mobile_no || '',
          email: data.email || '',
        });
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [pk]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.patch(`https://terracharms.com/edit_seller_profile/${pk}/`, formData);
      console.log('Edit Response:', response.data);
      alert('Profile updated successfully');
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Failed to update profile');
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className='accountsettings'>
      <h1 className='mainhead1'>Personal Information</h1>

      <div className='form'>
        <form onSubmit={handleSubmit}>
          <div className='form-group'>
            <label htmlFor='Name'>Your Name <span>*</span></label>
            <input
              type='text'
              name='Name'
              id='Name'
              value={formData.Name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className='form-group'>
            <label htmlFor='Mobile_no'>Phone/Mobile <span>*</span></label>
            <input
              type='text'
              name='Mobile_no'
              id='Mobile_no'
              value={formData.Mobile_no}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className='form-group'>
            <label htmlFor='email'>Email <span>*</span></label>
            <input
              type='email'
              name='email'
              id='email'
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <button type='submit' className='mainbutton1'>
            Save Changes
          </button>
        </form>
      </div>
    </div>
  );
};

export default SAccountSettings;
